import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "w-100" }
const _hoisted_2 = { class: "priority-needs pb-5 container" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-lg-9" }
const _hoisted_5 = { class: "container pb-5" }
const _hoisted_6 = { class: "container-fluid" }
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "col-lg-3" }
const _hoisted_9 = { class: "card shadow-sm border-0 px-3 bg-primary" }
const _hoisted_10 = { class: "row" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex justify-content-center pb-3" }, [
  /*#__PURE__*/_createElementVNode("button", {
    class: "btn btn-light p-1 mx-1 rounded-circle",
    "aria-label": "pagination dots"
  }),
  /*#__PURE__*/_createElementVNode("button", {
    class: "btn btn-light p-1 mx-1 rounded-circle",
    "aria-label": "pagination dots"
  }),
  /*#__PURE__*/_createElementVNode("button", {
    class: "btn btn-light p-1 mx-1 rounded-circle",
    "aria-label": "pagination dots"
  })
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ScrollArea = _resolveComponent("ScrollArea")!
  const _component_CardList = _resolveComponent("CardList")!
  const _component_Pagination = _resolveComponent("Pagination")!
  const _component_Card = _resolveComponent("Card")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("section", _hoisted_5, [
            _createVNode(_component_ScrollArea, { onProgramId: _ctx.programArea }, null, 8, ["onProgramId"])
          ]),
          _createElementVNode("section", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listDatas, (data) => {
                return (_openBlock(), _createBlock(_component_CardList, {
                  key: data.title,
                  body: data,
                  card: _ctx.cardListDetails
                }, null, 8, ["body", "card"]))
              }), 128))
            ]),
            _createVNode(_component_Pagination, { class: "d-none" })
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sideDatas, (data) => {
                return (_openBlock(), _createBlock(_component_Card, {
                  key: data.id,
                  body: data,
                  card: _ctx.cardDetails
                }, null, 8, ["body", "card"]))
              }), 128))
            ]),
            _hoisted_11
          ])
        ])
      ])
    ])
  ]))
}